import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type UpdatePartnerUserRoleInput = {
  partnerId: string;
  partnerUserId: string;
  role: string;
};

// PATCH /api/partners/:id/users/:userId/role
//
// Sets role_at_partner (free text, max 200 chars). Header on partner
// detail page shows the primary contact's role — keep partners.detail
// invalidated alongside the users list.
export function useUpdatePartnerUserRole() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, UpdatePartnerUserRoleInput>({
    mutationFn: ({ partnerId, partnerUserId, role }) =>
      apiFetch<{ ok: true }>(`/partners/${partnerId}/users/${partnerUserId}/role`, {
        method: "PATCH",
        body: JSON.stringify({ role }),
      }),
    onSuccess: (_data, { partnerId }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.partners.users(partnerId) });
      queryClient.invalidateQueries({ queryKey: queryKeys.partners.detail(partnerId) });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to update role");
    },
  });
}
